<template>
  <div class="container p-0">
    <div class="featured-channels">
      <h2 class="featured-channels-title" v-html="$t('freemium.featuredChannels.title')"></h2>
      <p v-if="!mobile" class="featured-channels-content" v-html="$t('freemium.featuredChannels.content')">
      </p>
      <v-slide-group v-model="model" show-arrows :mobile="mobile">
        <v-slide-group-item
          v-for="(item, index) in featuredChannels"
          :key="index"
        >
          <v-card
            style="margin-left: 25px; margin-right: 25px"
            :height="mobile ? 130 : 150"
            :width="mobile ? 130 : 150"
            :flat="true"
            :image="item"
            :color="'rgba(0, 0, 0, 0)'"
          >
          </v-card>
        </v-slide-group-item>
      </v-slide-group>
    </div>
    <router-link
        class="btn btn-danger btn-get-started d-block my-5 mx-auto"
        :to="{ name: 'register' }"
        v-if="!mobile"
    >
      {{ $t("freemium.featuredChannels.cta") }}
    </router-link>
  </div>
</template>
<script>
import flixlatino from "@/assets/img/freemium/flixlatino.svg";
import pinguinitos from "@/assets/img/freemium/pinguinitos.svg";
import cine_horror from "@/assets/img/freemium/cine-horror.svg";
import cine_espanol from "@/assets/img/freemium/cine-espanol.svg";
export default {
  data: () => ({
    model: null,
  }),
  computed: {
    mobile() {
      return this.isMobile();
    },
    featuredChannels() {
      return [flixlatino, pinguinitos, cine_horror, cine_espanol];
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-get-started {
  width: 340px;
  @media screen and (max-device-width: 480px) {
    width: 300px;
  }
}
.featured-channels {
  align-items: center;
  &-title {
    text-align: center;
    margin-bottom: 50px;
  }
  &-content {
    position: relative;
    margin: 0 auto 50px auto;
    text-align: center;
    max-width: 800px;
  }
  .v-slide-group {
    max-width: 800px;
    margin: 0 auto 50px auto;
  }
}
</style>
